import Cookies from 'js-cookie';

export class CustomerTypeService {
    private readonly isB2b: boolean;

    constructor() {
        this.isB2b = Cookies.get('b2b-homepage') === '1' && Cookies.get('display-end-customer-price') !== '1';
    }

    isB2bCustomer(): boolean
    {
        return this.isB2b;
    }
}
